export default __webpack_public_path__ + "static/media/envelope.67888696.png";